import {Injectable, Input} from '@angular/core';
import {DashboardCard, IDashboardCard} from '../../common/modals/dashboard-card.class';

@Injectable({
  providedIn: 'root'
})
export class CompanyDashboardStateService {
  companyDetailsCard: DashboardCard;
  operativesListCard: DashboardCard;
  recentObservationsListCard: DashboardCard;
  recentDocumentsCard: DashboardCard;
  cardsSet: boolean;
  constructor() {
    this.cardsSet = false;
  }
  setDashboardState(companyDetailsCard, operativesListCard, recentObservationsListCard, recentDocumentsCard) {
    this.companyDetailsCard = companyDetailsCard;
    this.operativesListCard = operativesListCard;
    this.recentObservationsListCard = recentObservationsListCard;
    this.recentDocumentsCard = recentDocumentsCard;
    this.cardsSet = true;
  }
  getCompanyDetailsCard(): DashboardCard {
    return this.companyDetailsCard;
  }
  getOperativesListCard(): DashboardCard {
    return this.operativesListCard;
  }
  getRecentObservationsListCard(): DashboardCard {
    return this.recentObservationsListCard;
  }
  getRecentDocumentsCard(): DashboardCard {
    return this.recentDocumentsCard;
  }
}
